module.exports = __webpack_public_path__ + "img/join-movement-graphic.eb4b15b2.svg";